import type { PermissionData } from '../types'

export function computeLockPermission(permissionData: PermissionData) {
  if (permissionData.allRoutesLocked) return 'hidden'
  if (!permissionData.allRoutesAvailable) return 'disabled'

  return 'enabled'
}
